module.exports = __webpack_public_path__ + "img/nbcover.a2f5f004.png";